import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { memo, type ReactElement, useCallback } from "react"

import { SelectItemTemplate } from "../../../components/MenuGroups/constants"
import { useFallbackEditor, useTextStyleState } from "../../hooks"
import type { OptionalEditorProps } from "../typings"

type LineHeightDropdownSelectProps = Omit<MenuRootProps, "children"> &
	Omit<MenuClickTriggerProps, "children"> &
	MenuVariantProps &
	OptionalEditorProps & {
		children: ReactElement
	}

export const LineHeightDropdownSelect = memo<LineHeightDropdownSelectProps>((props) => {
	const {
		// Trigger props
		disabled = false,
		children,
		// MenuContent props
		radius,
		size,
		variant,
		accentColor,

		// editor props
		editor: editorFromProps,
		...rest
	} = props

	const editor = useFallbackEditor(editorFromProps)
	const state = useTextStyleState(editor)

	const handeValueChange = useCallback(
		(lineHeight: string | undefined) => {
			if (lineHeight) {
				editor.chain().focus().setLineHeight(lineHeight).run()
			} else {
				editor.chain().focus().unsetLineHeight().run()
			}
		},
		[editor],
	)

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} radius={radius} accentColor={accentColor} variant={variant}>
				<Menu.SelectGroup<string> required={false} value={state.lineHeight} onValueChange={handeValueChange}>
					<SelectItemTemplate<string> value="1.0">Single</SelectItemTemplate>
					<SelectItemTemplate<string> value="1.15">1.15</SelectItemTemplate>
					<SelectItemTemplate<string> value="1.5">1.5</SelectItemTemplate>
					<SelectItemTemplate<string> value="2.0">Double</SelectItemTemplate>
				</Menu.SelectGroup>
			</Menu.Content>
		</Menu.Root>
	)
})
LineHeightDropdownSelect.displayName = "LineHeightDropdownSelect"
